// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store/index.js'
import './style/common.scss'
import '@/directives/index.js'
import BaiduMap from 'vue-baidu-map'
// 过滤器
import * as filters from '@/filters'
for (let filter in filters) {
	if (Object.hasOwnProperty.call(filters, filter)) {
		Vue.filter(filter, filters[filter])
	}
}

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: '7jW31MBpfA4hRz4joaBtLGfPmZ89Mgki'
})
Vue.use(ElementUI)
Vue.config.productionTip = false

import './components'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js